var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _path8, _ellipse2, _path9, _ellipse3, _circle, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEquity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 48H8v16h39.5",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 55.4l3-2.4 3 2.4V59h-6v-3.6zM29 53h6v6h-6z",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 56h4M39 54h4M39 57h4",
    stroke: "#10C98E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 31v-9l-6 9h6z",
    fill: "#E1F8F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26v16h21M13 25l17.5-15 13 12",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M26 23h9v9h-9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.384 48.394c0 1.335-5.683 2.417-12.692 2.417-7.01 0-12.692-1.082-12.692-2.417v-3.627c2.697 0 23.328-.273 25.384 0v3.627z",
    fill: "#E1F8F1",
    stroke: "#10C98E",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.692,
    cy: 44.767,
    rx: 12.692,
    ry: 2.417,
    fill: "#E1F8F1",
    stroke: "#10C98E",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.384 39.786c0 1.335-5.683 2.418-12.692 2.418-7.01 0-12.692-1.083-12.692-2.418V36.16c2.697 0 23.328-.273 25.384 0v3.626z",
    fill: "#E1F8F1",
    stroke: "#10C98E",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.692,
    cy: 36.16,
    rx: 12.692,
    ry: 2.417,
    fill: "#E1F8F1",
    stroke: "#10C98E",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.384 31.044c0 1.335-5.683 2.417-12.692 2.417-7.01 0-12.692-1.082-12.692-2.417v-3.626c2.697 0 23.328-.274 25.384 0v3.626z",
    fill: "#E1F8F1",
    stroke: "#10C98E",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.692,
    cy: 27.418,
    rx: 12.692,
    ry: 2.417,
    fill: "#E1F8F1",
    stroke: "#10C98E",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.251,
    cy: 56.251,
    r: 12.251,
    fill: "#FFF7EE",
    stroke: "#7E776E",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M57.98 59.987a.961.961 0 00-.626 1.817l.626-1.817zm1.933 1.292l.005-.961h-.005v.96zm2.655-1.869l.947.164-.947-.163zm-.794-2.155l.613-.74-.002-.002-.611.742zm-2.196-.693l-.181.944h.007l.174-.944zm-1.718-.847l-.741.61.004.006.737-.616zm-.504-1.862l-.947-.163-.001.006.948.157zm2.655-1.867l-.003.96.003-.96zm1.912 1.283a.961.961 0 00.668-1.802l-.668 1.802zm-4.256 7.627l-.313.909h.003l.005.002a.754.754 0 00.061.02l.164.05c.137.04.33.094.563.147a8.159 8.159 0 001.762.215l.002-1.921c-.471 0-.956-.081-1.337-.168a7.6 7.6 0 01-.567-.153l-.027-.009-.005-.001h.001l-.312.909zm2.24 1.343a4.135 4.135 0 002.183-.61c.676-.424 1.261-1.107 1.425-2.055l-1.894-.327c-.052.3-.235.555-.552.754a2.215 2.215 0 01-1.15.317l-.012 1.922zm3.608-2.665a3.27 3.27 0 00-1.128-3.059l-1.227 1.48c.36.298.542.786.461 1.252l1.894.327zm-1.13-3.06c-.46-.38-.978-.565-1.428-.676-.41-.101-.917-.169-1.206-.221l-.347 1.89c.46.084.746.112 1.094.197.308.076.515.17.665.293l1.222-1.483zm-2.627-.896c-.594-.114-.952-.27-1.16-.52l-1.475 1.233c.658.787 1.59 1.043 2.274 1.174l.361-1.887zm-1.156-.515a1.4 1.4 0 01-.298-1.092l-1.896-.315a3.32 3.32 0 00.71 2.63l1.484-1.223zm-.3-1.086c.069-.394.235-.625.455-.776.242-.167.64-.297 1.25-.295l.007-1.921c-.862-.003-1.684.177-2.347.633-.686.472-1.11 1.178-1.258 2.032l1.894.327zm1.706-1.07a6.228 6.228 0 011.892.314l.022.008.003.001h-.001-.001l.334-.902.334-.9v-.001h-.001l-.002-.001a.122.122 0 00-.005-.002l-.015-.005a2.89 2.89 0 00-.206-.068 8.139 8.139 0 00-2.349-.366l-.005 1.921z",
    fill: "#7E776E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M60.198 62.048l.001 2.073M60.218 49.03l-.005 2.02",
    stroke: "#7E776E",
    strokeWidth: 1.922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgEquity;